module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "SP"
  }), _vm._v(" "), _c('section', {
    attrs: {
      "aria-labelledby": "ch4",
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "Chap-Title-ct",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "34",
      "id": "pg_34",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "cn"
  }, [_vm._v("4.")]), _vm._v(" THE ADMAN BEFORE "), _c('i', [_vm._v("MAD MEN")])])])])]), _vm._v(" "), _c('blockquote', {
    attrs: {
      "epub:type": "epigraph",
      "role": "doc-epigraph"
    }
  }, [_c('p', {
    staticClass: "Chap-Epigraph-non-verse-cepi"
  }, [_c('i', [_vm._v("Sometimes we don’t get to choose where our talents lie.")])]), _vm._v(" "), _c('p', {
    staticClass: "Chap-Epigraph-Source-ceps"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("—DON DRAPER,")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-I-SC"
  }, [_vm._v("MAD MEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_c('span', {
    staticClass: "cic"
  }, [_vm._v("S")]), _vm._v("o Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" reviewed the back copies of "), _c('i', [_vm._v("Collier’s Once a Week")]), _vm._v(" and the previous year’s advertisements in "), _c('i', [_vm._v("Collier’s Weekly.")]), _vm._v(" He saw a thin, dull fortnightly that was more about current events than good fiction. What little advertising it had was a matter of widespread and general concern. Advertisements were placed at the back of the book, sold by the fraction of a column inch. What "), _c('i', [_vm._v("Collier’s")]), _vm._v(" needed to consider, in Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v("’s opinion, was if it wanted to appeal to a specific market, and if so, which one.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Collier had made huge investments in "), _c('i', [_vm._v("Collier’s Weekly")]), _vm._v(" since taking over, employing top illustrators and writers, and using the state-of-the-art technology of “color.” When all was said and done, fiction was a broad market, and that troubled Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(". Advertisers in such a journal would be showing off their goods to a wide range of readers, making their ads more miss than hit. Collier saw the merit of Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v("’s analysis to aim for a discrete market, but with a raft of satisfied advertisers who made the magazine almost wash its face, any change made Collier uneasy. Soap, three-dollar men’s shoes, bicycles, and all manner of medicinal “cure-alls” were the backbone of the company’s profits. Still, if advertising Procter & Gamble’s Ivory Soap—“99 < % pure” and “It floats”—made Collier sleep better, it certainly wouldn’t hurt Aunt Fanny Gamble’s pocket either."), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch4#notes-ch4-1",
      "id": "notes-ch4_1",
      "role": "doc-noteref"
    }
  }, [_vm._v("1")])]), _vm._v(" Besides, the magazine did a wonderful job adver"), _c('span', {
    attrs: {
      "aria-label": "35",
      "id": "pg_35",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("tising the popular novels in Collier’s Library, which was still the company’s bread and butter.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("What Collier hadn’t realized was that Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" had hit on a gold-plated genius reason to create a class publication. Circulation numbers stood at a paltry 19,159. For advertisers who wanted to get their products known nationally, it held little appeal. Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v("’s experience in approaching modern-day industries about promoting their products backed up his research, too. "), _c('i', [_vm._v("Collier’s Weekly")]), _vm._v(" could successfully advertise novels—even novels to take on holiday—but selling the aspirational vacation itself, or how to make one’s travel plans, was missing. Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" knew when he said, “I have so many hundred thousand readers, among them there must be a great number rich enough to buy your car,” it would be a point scorer for the executive placing his ads in "), _c('i', [_vm._v("Automobile and Motor Age")]), _vm._v("."), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch4#notes-ch4-2",
      "id": "notes-ch4_2",
      "role": "doc-noteref"
    }
  }, [_vm._v("2")])]), _vm._v(" He was aware, too, that the majority of general readers couldn’t afford to purchase pianos, private education, jewelry from Tiffany & Co., or the $250 Victor-Victrola, much less the recordings to play on it."), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch4#notes-ch4-3",
      "id": "notes-ch4_3",
      "role": "doc-noteref"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("So the bulk of "), _c('i', [_vm._v("Collier’s")]), _vm._v(" advertising concentrated on affordable soaps (Pear’s, Fairy, and Ivory); home remedies (such as Dent’s Toothache Gum, Beeman’s Dental Gum, the Philo Burt corset for spinal deformities, Parker’s Ginger Tonic for the avoidance of appendicitis brought on by constipation); corsets and hosiery (for instance the all-over Oneita rubber suit or Thomson’s Glove Fitting Corsets and President Suspenders); household goods (like the Enterprise Food Chopper or the Electric Works’ “Electronic Wonders at Little Cost”) and foodstuffs (Ralston breakfast foods, Grape-Nuts). Occasionally a piano or two would crop up, but these were the exception."), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch4#notes-ch4-4",
      "id": "notes-ch4_4",
      "role": "doc-noteref"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Despite his skepticism Collier agreed that Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" could make important changes to the national advertising sales campaign for "), _c('i', [_vm._v("Collier’s")]), _vm._v(". Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" was the first adman in the United States to introduce a systematic division of the country into territories for the sale of advertising space, with key divisional offices located within each region. Nonetheless he remained wedded to the idea of a class publication, and persuaded Collier to create “class” special issues, like the automotive and yachting specials. Over time Collier agreed "), _c('span', {
    attrs: {
      "aria-label": "36",
      "id": "pg_36",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("to theme his fortnightly magazine as Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" suggested. So, for example, the October 5, 1901, edition concentrated on the sea, with an update on the thrilling America’s Cup race, a report on Rear Adm. Winfield Scott Schley’s court of inquiry,"), _c('sup', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/footnotes#footnote-109",
      "id": "footnote-109-backlink",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" and a short story called “The Pirate’s Daughter.”"), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch4#notes-ch4-5",
      "id": "notes-ch4_5",
      "role": "doc-noteref"
    }
  }, [_vm._v("5")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Not only did Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" influence the creation of special numbers, but he also gave advice regarding "), _c('i', [_vm._v("Collier’s")]), _vm._v(" look and feel. Circulation soared. Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" was aware that few believed unaudited circulation figures, so he arranged for these to be independently assessed. The numbers didn’t lie. Maxfield Parrish, one of the more popular magazine illustrators, became a regular contributor. Frederic Remington contributed Western action illustrations. Collier was thrilled. He spent lavishly on stories and articles by some of the top writers of the day like Frank Norris, Rudyard Kipling, O. Henry, Booth Tarkington, Jack London, Winston Churchill, Edith Wharton, P. G. Wodehouse, and Arthur Conan Doyle among others."), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch4#notes-ch4-6",
      "id": "notes-ch4_6",
      "role": "doc-noteref"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("But the real “snatch” was Charles Dana Gibson in 1903. Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" urged Collier to woo the fabulously popular Gibson, dubbed “the darling of the nineties,” who was deemed the near-exclusive property of "), _c('i', [_vm._v("Life.")]), _c('sup', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/footnotes#footnote-108",
      "id": "footnote-108-backlink",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" With Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" firmly at his side, Collier persuaded Gibson to join him. Collier signed up Gibson, with his customary largesse, for one hundred two-page drawings to appear over four years. The cost? A staggering one hundred thousand dollars, or "), _c('span', {
    attrs: {
      "aria-label": "37",
      "id": "pg_37",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("double Gibson’s usual fee."), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch4#notes-ch4-7",
      "id": "notes-ch4_7",
      "role": "doc-noteref"
    }
  }, [_vm._v("7")])]), _vm._v(" The following year Gibson was rewarded with his own special issue.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-Space-After-tx-"
  }, [_vm._v("Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" had a good story to tell advertisers, but he told it in an engaging and self-effacing way. “I am the Advertising Manager of "), _c('i', [_vm._v("Collier’s")]), _vm._v(",” so his pitch began:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "Extract-No-Indent-ext1"
  }, [_c('i', [_vm._v(" … I don’t expect you to give me any business. Most manufacturers don’t believe in weeklies; and it has only taken three months’ canvassing to prove to my perfect satisfaction that the few who do won’t use")]), _vm._v(" "), _c('i', {
    staticClass: "extract-no-indent-ext1-_span-italic-characters-ital"
  }, [_vm._v("Collier’s")]), _c('i', [_vm._v(". However, I accept the situation, I don’t want to argue with you. I merely want your residence address: We want to send")]), _vm._v(" "), _c('i', {
    staticClass: "extract-no-indent-ext1-_span-italic-characters-ital"
  }, [_vm._v("Collier’s")]), _vm._v(" "), _c('i', [_vm._v("to you regularly. Certain things are going to happen; things that you have neither the time nor inclination to enquire into.")]), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch4#notes-ch4-8",
      "id": "notes-ch4_8",
      "role": "doc-noteref"
    }
  }, [_vm._v("8")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-Space-Before--tx"
  }, [_vm._v("Advertisers lapped up the soft sell, and circulation soared again. When it hit the three hundred thousand watershed, Collier decided to take a step back and hired Harvard Law School graduate Norman Hapgood as his editor in 1902. Hapgood was thirty-four and had a reputation for being a scholar, journalist, and connoisseur of the arts. The change was heralded publicly as Collier’s recognition that Hapgood would bring his magazine the same prestige already enjoyed by "), _c('i', [_vm._v("Harper’s Weekly")]), _vm._v(" for its influence in public affairs."), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch4#notes-ch4-9",
      "id": "notes-ch4_9",
      "role": "doc-noteref"
    }
  }, [_vm._v("9")])]), _vm._v(" In fact, the reason was more prosaic: Robert Collier was getting married.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Of course Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" was invited to the celebrations. That July the wedding took place at the home of the bride’s father, James J. Van Alen, in Newport, Rhode Island, where only family and intimate friends attended. The bride, Miss Sara Stewart Van Alen, daughter of James Van Alen and Emily Astor, had recently converted to Roman Catholicism. To win Miss Van Alen’s hand, Collier needed the “approval” of the leader of high society’s Four Hundred, Mrs. Caroline Schermerhorn Astor, who was also the bride’s grandmother. “Since that hour,” the newspaper reported, “his final success has been assured … he is popular with the younger [society] set in Newport and New York.” The article also took a sideswipe "), _c('span', {
    attrs: {
      "aria-label": "38",
      "id": "pg_38",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("at Robert’s father, Peter Fenelon Collier, “as a keen cross-country rider” who had “galloped himself into the 400,”"), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch4#notes-ch4-10",
      "id": "notes-ch4_10",
      "role": "doc-noteref"
    }
  }, [_vm._v("10")])]), _vm._v(" referring to his purchase of the best hunters in County Meath, Ireland, and his donation of trophies for most of the horse shows he entered and—oh, by the way—won. It also mentioned that “on the arrival of Count Castellane in the United States, it is alleged that he [Fenelon Collier] befriended the count in a substantial manner when the latter was laying siege to the heart and the fortunes of Anna Gould.”"), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch4#notes-ch4-11",
      "id": "notes-ch4_11",
      "role": "doc-noteref"
    }
  }, [_vm._v("11")])]), _vm._v(" Anna, who was unkindly described as having facial warts, a clubfoot, and the face of a captured chimpanzee, was the youngest daughter of the robber baron Jay Gould, also known as the Vampire of Wall Street."), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch4#notes-ch4-12",
      "id": "notes-ch4_12",
      "role": "doc-noteref"
    }
  }, [_vm._v("12")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("In truth Fenelon Collier financed the bankrupt Count Boni de Castellane’s quest to secure Anna Gould’s heart and fortune, since he had neither to call his own. But with Fenelon Collier’s money and the count’s aristocratic good looks, Anna persuaded her family that it was true love. Fortunately, the Four Hundred were happy to turn a blind eye to Fenelon Collier’s actions, since Anna’s father had ensured that his family would not be fully accepted in high society."), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch4#notes-ch4-13",
      "id": "notes-ch4_13",
      "role": "doc-noteref"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Such high society would have dazzled—perhaps even daunted—a man of less fortitude and determination than Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(". Rather than be impressed, however, he used his exposure to Collier’s friends and in-laws as a learning experience, for he too had ambitions to become one of the Four Hundred.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba396f0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter4.vue
// module id = 90
// module chunks = 0